import * as React from 'react';

import { sections } from 'components/lexemes';

import { Badges } from 'components/badges/badges';
import { CtaBox, CtaBoxText } from 'components/cta-box';
import { P1 } from 'components/typography';

export const getPropsSectionOneTextContainer = () => {
  const lists = [sections.tabOneSection.section1.list(), sections.tabOneSection.section1.listTwo()];
  const indexIconIndexList = [
    // -1: no icon (Handle)
    [0, 1, 2, 3, -1],
    [4, 5, 6],
  ];

  const listsTwo = [
    sections.tabOneSection.section1.listThree(),
    sections.tabOneSection.section1.listFour(),
  ];
  const indexIconIndexListTwo = [[7, 9], [8]];

  const sectionOneText = (
    <>
      <CtaBox align="start">
        <CtaBoxText>
          <P1 html={sections.tabOneSection.section1.text1()} as="p" />

          <div className="registration-information-badges">
            <Badges lists={lists} indexList={indexIconIndexList} />
          </div>

          <div className="registration-information-badges registration-information-badges--vertical">
            <Badges lists={listsTwo} indexList={indexIconIndexListTwo} />
          </div>

          <P1 html={sections.tabOneSection.section1.text2()} as="p" />
        </CtaBoxText>
      </CtaBox>
    </>
  ) as unknown as string;
  return sectionOneText;
};
